import React from 'react'
import { withTranslation } from 'react-i18next'
import * as UIcons from '@iconscout/react-unicons'
import ReportFormatTag from './ReportFormatTag'
import ReportStatusTag from './ReportStatusTag'
import ReportRowActions from './ReportRowActions'

const COLUMN_WIDTHS = {
  type: 'w-[120px]',
  period: 'w-[170px]',
  generated: 'w-[140px]',
  format: 'w-[100px]',
  status: 'w-[120px]'
}

export default withTranslation()(function RecentReportsTable({ t, reports = [], onDownload, onDelete }) {
  const columns = t('reports.recent.columns', { returnObjects: true })

  return (
    <div className="bg-white rounded-2xl border border-border-lines">
      <p className="text-base font-semibold text-dark-blue px-4 pt-4 pb-3">{t('reports.recent.title')}</p>

      <div className="w-full overflow-x-auto">
        <div className="min-w-[920px]">
          <div className="flex items-center bg-background border-y border-border-lines">
            <div className="flex-1 min-w-[220px] px-4 py-2.5 text-sm font-semibold text-dark-blue">{columns.name}</div>
            <div className={`${COLUMN_WIDTHS.type} shrink-0 px-2 py-2.5 text-sm font-semibold text-dark-blue`}>{columns.type}</div>
            <div className={`${COLUMN_WIDTHS.period} shrink-0 px-2 py-2.5 text-sm font-semibold text-dark-blue`}>{columns.period}</div>
            <div className={`${COLUMN_WIDTHS.generated} shrink-0 px-2 py-2.5 text-sm font-semibold text-dark-blue`}>{columns.generated_on}</div>
            <div className={`${COLUMN_WIDTHS.format} shrink-0 px-2 py-2.5 text-sm font-semibold text-dark-blue`}>{columns.format}</div>
            <div className={`${COLUMN_WIDTHS.status} shrink-0 px-2 py-2.5 text-sm font-semibold text-dark-blue`}>{columns.status}</div>
            <div className="w-24 shrink-0" />
          </div>

          {
            reports.length === 0 && (
              <div className="flex flex-col items-center gap-3 py-16 text-center px-4">
                <div className="w-16 h-16 rounded-full bg-icon-bg flex items-center justify-center">
                  <UIcons.UilFolderOpen size={30} className="text-primary" />
                </div>
                <p className="text-base font-semibold text-dark-blue">{t('reports.recent.empty_title')}</p>
                <p className="text-sm text-secondary max-w-sm">{t('reports.recent.empty_hint')}</p>
              </div>
            )
          }

          {
            reports.map((report) => (
              <div key={report.id} className="flex items-center border-b border-border-lines last:border-b-0 h-[74px]">
                <div className="flex-1 min-w-[220px] px-4">
                  <p className="text-sm text-dark-blue truncate">{report.name}</p>
                  <p className="text-xs text-secondary truncate">{report.subtitle}</p>
                </div>

                <div className={`${COLUMN_WIDTHS.type} shrink-0 px-2`}>
                  <p className="text-sm text-dark-blue truncate">{report.typeLabel}</p>
                </div>

                <div className={`${COLUMN_WIDTHS.period} shrink-0 px-2`}>
                  <p className="text-sm text-dark-blue truncate">{report.periodLabel}</p>
                </div>

                <div className={`${COLUMN_WIDTHS.generated} shrink-0 px-2`}>
                  <p className="text-sm text-dark-blue">{report.generatedOnLabel}</p>
                  <p className="text-xs text-secondary">{report.generatedAt}</p>
                </div>

                <div className={`${COLUMN_WIDTHS.format} shrink-0 px-2`}>
                  <ReportFormatTag format={report.format} />
                </div>

                <div className={`${COLUMN_WIDTHS.status} shrink-0 px-2`}>
                  <ReportStatusTag status={report.status} />
                </div>

                <div className="w-24 shrink-0 flex items-center justify-end pr-4">
                  <ReportRowActions report={report} onDownload={onDownload} onDelete={onDelete} />
                </div>
              </div>
            ))
          }
        </div>
      </div>
    </div>
  )
})
